import React, { useState } from 'react';

import { ControlledMenu, MenuItem, MenuHeader, MenuDivider } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';

import { 
  AiModal,
  AiModalHeader,
  AiModalBody,
  AiModalFooter,
  
  AiModalStyledTextArea,
  AiBtnWhite,
} from './editor-context-menu.styles';

import { PROCESS_TEXT_USING_AI } from '@graphql/ai';
import { useMutation } from '@apollo/client';

const EditorContextMenu = (props) => {
  const {getContextMenuState, setContextMenuState, getContextMenuAnchorPoint, setContextMenuAnchorPoint, getContent, quillRef} = props;
  
  const [getAiTextHeader, setAiTextHeader] = useState('');
  const [getAiText, setAiText] = useState('');
  const [getAiTextStatus, setAiTextStatus] = useState('WAITING');

  const [processTextUsingAi, { data:dataUpdate, loading:loadingUpdate, error:errorUpdate }] = useMutation(PROCESS_TEXT_USING_AI);
  
  const processClickOnAiContextMenuItem = (e, setContextMenuState, newState, setAiText, quillRef) => {
    e.syntheticEvent.target.classList.add('szh-menu__item--hover');
    setContextMenuState(newState);

    let selection = quillRef.current.unprivilegedEditor.getSelection(true);
    let selectedContent = quillRef.current.unprivilegedEditor.getContents(selection.index, selection.length);
    
    let originalText = null;
    if (selectedContent?.ops.length && selectedContent.ops[0].insert) {
      originalText = selectedContent.ops[0].insert;
    } else {
      originalText = getContent?.content || '';
    }

    setAiTextStatus('WAITING');
    setAiText('');
    processTextUsingAi({
      variables: {
        text: originalText,
        mode: newState,
      }
    }).then((res) => {
      const processedText = res.data.aiTextProcessingProcessText;
      if (processedText) {
        setAiTextStatus('FINISHED');
        setAiText(processedText);
      } else {
        setAiTextStatus('FAILED');
        setAiText("К сожалению, предоставленный текст обработать не удалось.");
      }
    })
  }

  const buildContextMenuContentByState = (contextMenuState) => {
    if (['OPENED_BY_RIGHTCLICK', 'OPENED_BY_ICON'].includes(contextMenuState)) {
      return (
        <>
          {contextMenuState == 'OPENED_BY_RIGHTCLICK' && (
            <>
              <MenuItem onClick={(e) => processClickOnCut()} disabled={!checkIfSelectionExists()}>Вырезать</MenuItem>
              <MenuItem onClick={(e) => processClickOnCopy()} disabled={!checkIfSelectionExists()}>Копировать</MenuItem>
              <MenuItem onClick={(e) => processClickOnPaste()}>Вставить</MenuItem>
              <MenuDivider />
            </>
          )}
          <MenuHeader>ИИ-тексты:</MenuHeader>
          <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'SUMMARIZE_BY_POINTS', setAiText, quillRef)}>Извлечь ключевые моменты</MenuItem>
          <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'GENERATE_QUESTIONS', setAiText, quillRef)}>Сгенерировать вопросы</MenuItem>
          <MenuItem onClick={(e) => processClickOnAiContextMenuItem(e, setContextMenuState, 'EXPLAIN_THIS', setAiText, quillRef)}>Объяснить простыми словами</MenuItem>
        </>
      );
    }

    const buildAiTextHeaderByState = (contextMenuState) => {
      if (contextMenuState == 'IMPROVE_WRITING') {
        return 'Улучшенный ИИ текст:';
      }
      if (contextMenuState == 'SUMMARIZE_BY_POINTS') {
        return 'Извлеченные ИИ ключевые моменты:';
      }
      
      if (contextMenuState == 'GENERATE_QUESTIONS') {
        return 'Сгенерированные ИИ вопросы:';
      }
      if (contextMenuState == 'EXPLAIN_THIS') {
        return 'Объяснение от ИИ:';
      }
    }

    const statesWithTextArea = [
      'IMPROVE_WRITING',
      'SUMMARIZE_BY_POINTS',
      'GENERATE_QUESTIONS',      
      'EXPLAIN_THIS',
    ];
    if (statesWithTextArea.includes(contextMenuState)) {
      return (
        <AiModal>
          <AiModalHeader>{buildAiTextHeaderByState(contextMenuState)}</AiModalHeader>
          <AiModalBody>
            <AiModalStyledTextArea value={getAiText} placeholder="Подождите, идёт обработка текста..." readonly={ ['WAITING', 'FAILED'].includes(getAiTextStatus) } />
          </AiModalBody>
          <AiModalFooter>
            <AiBtnWhite onClick={(e) => setContextMenuState('CLOSED')}>Закрыть</AiBtnWhite>
          </AiModalFooter>
        </AiModal>
      );
    }
    return (<></>);
  }

  const checkIfSelectionExists = () => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const range = quill.getSelection();
      let selectedText = "";

      if (range) {
        selectedText = quill.getText(range.index, range.length);
      }

      if (!(selectedText == null || selectedText == '')) {
        return true;
      }
    }
    return false;
  };

  const processClickOnCopy = () => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const range = quill.getSelection();
      let selectedText = "";

      if (range) {
        selectedText = quill.getText(range.index, range.length);
      }

      if (selectedText) {
        navigator.clipboard.writeText(selectedText);
      }
    }
    setContextMenuState('CLOSED');
  };

  const processClickOnCut = () => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const range = quill.getSelection();
      let selectedText = "";

      if (range) {
        selectedText = quill.getText(range.index, range.length);
      }

      if (selectedText) {
        navigator.clipboard.writeText(selectedText).then(() => {
          quill.deleteText(range.index, range.length);
        });
      }
    }
    setContextMenuState('CLOSED');
  };

  const processClickOnPaste = () => {
    if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        navigator.clipboard.readText().then(clipText => {
            const range = quill.getSelection();
            if (range) {
                quill.deleteText(range.index, range.length);
                quill.insertText(range.index, clipText);
            } else {
                quill.insertText(quill.getLength(), clipText);
            }
        });
    }
    setContextMenuState('CLOSED');
};



  const handleOnBlur = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (e.target.classList.contains('szh-menu__item--hover')) {
      return;
    }
    if (e?.currentTarget?.contains(e?.relatedTarget)) {
      return;
    }

    if (['OPENED_BY_RIGHTCLICK', 'OPENED_BY_ICON'].includes(getContextMenuState)) {
      setContextMenuState('CLOSED');    
    }
  }

  return (
    <ControlledMenu
      anchorPoint={getContextMenuAnchorPoint}
      state={(getContextMenuState != 'CLOSED') ? 'open' : 'closed'}
      direction="right"
      onBlur={(e) => handleOnBlur(e)}
    >
      {buildContextMenuContentByState(getContextMenuState)}
    </ControlledMenu>
  );
};

export default EditorContextMenu;